import React, {cloneElement, useContext, useEffect, useState} from 'react';
import {useHistory} from 'react-router-dom';
import {TableColumn, TableSettings} from "../../../tableSettings";
import AbstractListView, {
  DataFetchResult,
  ExportRowRenderer,
  ListCustomFilterRenderer,ListOrderBy,ListRowRenderer
} from "../../common/AbstractListView";

import lockBlue from '../../../img/lock_blue.png';
import lockRed from '../../../img/lock_red.png';

import constants from '../../../constants';
import {Search} from "../../../filtering";

import {NavigationType, openNewPage} from '../../../util/navigationHelpers';

import {
  DateRenderer,DateTimeRenderer,
  NullableCheckboxIconRenderer,
  TextAlignLeftRenderer,TextRenderer
} from '../../../uiControls/SmartTableRenderers';
import UniqueLinkButton from '../../../uiControls/UniqueLinkButton';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import { faCalculator, faCopy, faFileAlt, faPencilAlt, faPlus, faTrashAlt, } from '@fortawesome/free-solid-svg-icons';
import useGlobalYesNoDialog from '../../../hooks/useGlobalYesNoDialog';
import ApplicationContext from '../../../ApplicationContext';
import JobListViewContext, { RightClickContext } from '../../common/JobListViewContext';
import useGlobalOkDialog from '../../../hooks/useGlobalOkDialog';
import {ActionButtonItem, borderColors, splitMenuItemsIntoSections} from '../../../ui/ActionButton';
import useFunctionKeys from '../../../hooks/useFunctionKeys';
import PrimaryButton from '../../../ui/PrimaryButton';
import InfoAreaDrawer from '../../../uiControls/infoArea/InfoAreaDrawer';
import {JobNames} from "../../../framework.core/JobNames";
import {brokerageTruckingLocalDOList} from "../tableSettings";
import IfmsModal from "../../../ui/IfmsModal";
import ListViewShortcutMenu from '../../common/ListViewShortcutMenu';
import ToolboxMenuItem from '../../../uiControls/ToolboxMenuItem';
import Menu, { IfmsMenuItem } from '../../../ui/menu/Menu';
import * as XCol from '../../../framework.core/XExportColumn';
import DeleteHistory from "../../reports/DeleteHistory";
import { FmsSubMenu } from '../../../constants/fmsSubMenu';
import { getSelectedSubMenuArgs } from '../../JobListSubMenu';
import useReportViewer from '../../../hooks/useReportViewer';
import postal from 'postal';
import loadInfoAreaInvoiceBillCrDb from '../../common/InfoAreaInvoiceBillCrDb';
import { FmsSecTask, ListFilterType } from '../../../fms.core/constants';
import { getFmsGlobal } from '../../../globals';
import { findSecurityTask } from '../../../util';
import { BTLocalDOListItem } from '../../../fms.data/models/BTLocalDOListItem';
import fastStorage from '../../../fastStorage';
import _ from 'lodash';
import { useTypedFastStorage } from '../../../hooks/useFastStorage';
import Select from '../../../ui/Select';
import useSetEditedId from '../../../hooks/useSetEditedId';
import PrimaryInverseButton from '../../../ui/PrimaryInverseButton';


function IndicatorRenderer({ data, row }: any) {
  const l = data[row.index];
  let dataTooltip = '';
  const lStatus = (l as any).status as string;
  if (lStatus === 'PC') dataTooltip = 'Period Close';
  else if (lStatus === 'OC') dataTooltip = 'OP Close';

  let content: React.ReactNode = <></>;
  if (lStatus === 'PC')
    content = <img height="7px" src={lockRed} id={'redIcon'} style={{ position: 'relative', top: '0px' }} alt="" />;
  else if (lStatus === 'OC')
    content = <img height="7px" src={lockBlue} id={'blueIcon'} style={{ position: 'relative', top: '0px' }} alt="" />;
  return (
    <div className="ifms-table-default" id={`ifms-table-default-${row.index}`} data-tooltip={dataTooltip} style={{ width: '100%', minHeight: '22px' }}>{content}</div>
  );
}

function OrderNoRenderer({cell,row,data}: any){
  const {switchToOrderDetail} = useLocalDoOperations();
  const l = data[row.index];
 if(!cell.value || l.orderCnt > 1){
     return <div className="ifms-table-default">{cell.value}</div>;
   }
 
   return <PrimaryInverseButton onClick={() => switchToOrderDetail(data[row.index])} style={{width: '100%', lineHeight:'1em'}}>{cell.value}</PrimaryInverseButton>
}

function useLocalDoOperations(){
  const history = useHistory();
  function switchToOrderDetail(localdo: BTLocalDOListItem|null){
    if(!localdo){
      return;
    }
    openNewPage(history, `/brokerageTrucking/order/view/${localdo.orderId}`, NavigationType.newPage );
  }

  return {switchToOrderDetail}
}

function useSelectedOperations() {
  const jobListContext = useContext(JobListViewContext);
  const appContext = useContext(ApplicationContext);
  const history = useHistory();

  const selectedElement = jobListContext.selectedElement as BTLocalDOListItem;

  const [showGlobalOkDialog] = useGlobalOkDialog();
  const [showGlobalYesNoDialog] = useGlobalYesNoDialog();
  const channel = postal.channel('ajax');
  const setBTOSavedEntity = useSetEditedId([JobNames.BTOrder]);

  async function create() {
    if (jobListContext.hasOpenedScreenStartingWithUrl('/brokerageTrucking/localDO/add')) {
      await showGlobalOkDialog(<p>New operation is already in progress.</p>);
      return;
    }

    openNewPage(history, '/brokerageTrucking/localDO/add', NavigationType.newPage);
  }

  async function deleteItem() {
    if (!selectedElement) {
      return;
    }

    if (
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/bill/view/BTDO/${selectedElement.id}`) ||
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/bill/edit/BTDO/${selectedElement.id}`) 
    ) {
      await showGlobalOkDialog('Need to close Bill first.');
      return;
    }

    const doDelete = await showGlobalYesNoDialog(
      <div>
        <h3>Confirm to Delete?</h3>
      </div>
    ,false,1,true,'warning');

    if (doDelete) {
      const apiResult = await appContext.api.deleteJobDetail(JobNames.BTDo, { id:selectedElement.id});
      if (apiResult && apiResult.success) {
        jobListContext.reloadData();
        setBTOSavedEntity('0', false, false, true);   // BT Order List > Do No 반영
      } else {
        const message = apiResult?.message ?? 'Cannot delete!';
        await showGlobalOkDialog(message,false,null,'warning');
      }
    }
  }

  async function viewBillings() {
    if (!selectedElement) {
      return;
    }

    const id = selectedElement.id;

    const viewUrl = `/brokerageTrucking/viewBillings/localDO/${id}`;

    if (jobListContext.hasOpenedScreenStartingWithUrl(viewUrl)) {
      await showGlobalOkDialog(<p>View operation is already in progress.</p>);
      return;
    }

    openNewPage(history, viewUrl, NavigationType.newPage);
  }


  async function edit() {
    if (!selectedElement) {
      return;
    }

    const id = selectedElement.id;
    const editUrl = `/brokerageTrucking/localDO/edit/${id}`;
    const viewUrl = `/brokerageTrucking/localDO/view/${id}`;


    // if (jobListContext.hasOpenedScreenStartingWithUrlWithoutMe('/brokerageTrucking/localDO/edit', editUrl)) {
    //   await showGlobalOkDialog(<p>Edit operation is already in progress.</p>);
    //   return;
    // }
    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(editUrl, [editUrl, viewUrl]);
  }

  async function view() {
    if (!selectedElement) {
      return;
    }

    const id = selectedElement.id;
    const editUrl = `/brokerageTrucking/localDO/edit/${id}`;
    const viewUrl = `/brokerageTrucking/localDO/view/${id}`;

    const listSec = findSecurityTask(appContext, FmsSecTask.BTLocalDO);
    const urls = [viewUrl];
    if(listSec?.grantEdit) urls.push(editUrl);
    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(viewUrl, urls);
  }

  async function copy() {
    if (!selectedElement) {
      return;
    }

    if (jobListContext.hasOpenedScreenStartingWithUrl('/brokerageTrucking/localDO/add')) {
      await showGlobalOkDialog(<p>New operation is already in progress.</p>);
      return;
    }

    const id = selectedElement.id;
    openNewPage(history, `/brokerageTrucking/localDO/add?copyId=${id}`, NavigationType.newPage);
  }


  async function switchToAcctInfo(ot:BTLocalDOListItem|null) {
    if (!ot) {
      return;
    }

    if (jobListContext.hasOpenedScreenStartingWithUrl(`/accounting/Acct/${JobNames.BTDo}/${ot.id}`)) {
      await showGlobalOkDialog(<p>View operation is already in progress.</p>);
      return;
    }
    
    openNewPage(history, `/accounting/Acct/${JobNames.BTDo}/${ot.id}`, NavigationType.newPage);
  }

  function switchToOrder() {
    if(!selectedElement) return;
    const url = `/common/joblistview/btOrder/order`;
    jobListContext.setFilterForScreenExternally(url, 'doNo', 'D/O #', selectedElement.doNo??'', 'update', false, true, null);
    openNewPage(history, url, NavigationType.newPage);
  }

  return {create, deleteItem, edit, view, copy, viewBillings, switchToAcctInfo, switchToOrder};
}

function RightClickMenu({dismiss}:{dismiss: VoidFunction}) {
  const { create, deleteItem, edit, view, copy, viewBillings, switchToOrder } = useSelectedOperations();
  const jobListContext = useContext(JobListViewContext);
  const selectedElement = jobListContext.selectedElement as BTLocalDOListItem;
  const appContext = useContext(ApplicationContext);
  const [showGlobalOkDialog] = useGlobalOkDialog();
  const listSec = findSecurityTask(appContext, FmsSecTask.BTLocalDO);

  async function processFileLock() {
    const fileLockResult = await appContext.api.opClose(JobNames.BTDo, selectedElement.id, !selectedElement.isClosed);
    if (!!fileLockResult) {
      await showGlobalOkDialog(fileLockResult, false, null, 'warning');
      return;
    }
    
    if (selectedElement.isClosed && jobListContext.hasOpenedScreenStartingWithUrl(`/brokerageTrucking/localDO/edit/${selectedElement.id}`)) {
      const editModelKey = `editBTLocalDO${selectedElement.id}-/brokerageTrucking/localDO/edit`;
      const keyMatch = _.keys(fastStorage).find(x => x.startsWith(editModelKey));
      if (keyMatch) {
        fastStorage[keyMatch].fileClosed = 0;
        fastStorage[keyMatch].isClosed = false;
        fastStorage[keyMatch].closedBy = '';
        fastStorage[keyMatch].closeDate = null;
      }
    }
    jobListContext.reloadData();
  }

  let showFileLock = (!selectedElement?.isClosed ? getFmsGlobal().CanFileLock : getFmsGlobal().CanFileUnlock);

  const items = [
    { label: 'New', shortcut: 'F2', separator: false, hidden: !listSec?.grantAdd },
    { label: 'View', shortcut: 'F9', separator: !listSec?.grantEdit && !listSec?.grantDel },
    { label: 'Edit', shortcut: 'F3', separator: !listSec?.grantDel, hidden: !listSec?.grantEdit },
    { label: 'Delete', shortcut: '', separator: true, hidden:!listSec?.grantDel, },
    { label: 'Go to Manifest List', shortcut: 'F6', seprarator: false },
    { label: 'Search', shortcut: 'F5', separator: false },
    { label: 'Memo', shortcut: 'F8', separator: true, newCol: true },
    { label: 'Copy', shortcut: 'Ctrl+F2', separator: !(!showFileLock || selectedElement.draft), hidden: !listSec?.grantAdd },
    { label: !selectedElement?.isClosed ? 'OP Close' : 'OP Open', shortcut: '', separator: true, hidden: !showFileLock || selectedElement.draft },
  ];

  const menuItems: ActionButtonItem[] = items.map((i, index) =>({
    label: <ToolboxMenuItem  name="btLocalDo-list-sub-menu" width="190px" label={i.label} shortcut={i.shortcut} />,
    separator: i.separator,
    selected: false,
    newCol: i.newCol,
    index,
    disabled: false,
    hidden: i?.hidden ?? false,
  }));

  function onMenuItemSelected(item:IfmsMenuItem) {
    switch (item.index) {
      case 0:
        create();
        break;
      case 1:
        view();
        break;
      case 2:
        edit();
        break;
      case 3:
        deleteItem();
        break;
      case 4:
        switchToOrder();
        break;
      case 5:
        jobListContext.triggerTableSearch('F5');
        break;
      case 6:
        jobListContext.setInfoAreaContent(jobListContext.infoAreaContent === 'memo' ? 'none' : 'memo');;
        break;
      case 7:
        copy();
        break;
      case 8:
        processFileLock();
        break;
      default:
        break;
    }
    dismiss();
  }

  return (
    <Menu
      variant="plain"
      items={splitMenuItemsIntoSections(menuItems)}
      mode="vertical"
      onMenuItemSelected={onMenuItemSelected}
      subMenuStyle={{
        minWidth: 150,
        whiteSpace: 'nowrap',
      }}
      menuStyle={(i: number) => ({
        maxHeight: '300px',
        overflowY: 'hidden',
        padding: 0,
        borderTop: `3px solid ${borderColors[i % borderColors.length]}`,
        paddingTop: 10,
      })}
    />
  );
}

function AfterMemoLogButtonCommands() {
  const jobListContext = useContext(JobListViewContext);
  const [listFilter, setListFilter, ] = useTypedFastStorage<number>('BTDo-ListFilter', 0);
  useEffect(() => {
    changeBTDoListData(listFilter || 0);
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [listFilter]);

  function changeBTDoListData(listFilter: number){
    let listFilterType = ListFilterType.All;

    switch(listFilter) {
      case 0: 
        listFilterType = ListFilterType.All;
        break;
      case 1: 
        listFilterType = ListFilterType.NotClosed;
        break;
      case 2: 
        listFilterType = ListFilterType.NotPickupYet;
        break;
    }
    
    jobListContext.setListFilterType(listFilterType);
  }
  
  
  const filterType =[
    {label: 'All', value: 0},
    {label: 'Not Closed', value: 1},
    {label: 'Not Picked up yet', value:2},
  ]

  return (
      <div style={{marginLeft:'10px', width:'180px', lineHeight:'14px'}}>
        <Select
          name="ifms-localdo-list-filter"
          placeholder="Filter"
          value={listFilter || 0}
          onChange={e => {setListFilter(Number(e.target.value))}}
          items={filterType}
        />
      </div>
 
  )
}

function TrancationImpactButtonCommands() {
  /*
  const jobListContext = useContext(JobListViewContext);
  const selectedElement = jobListContext.selectedElement as BTLocalDOListItem;
  const {switchJournal} = useJournal();
  const suntekSettings = useSuntekSettings();
  
  if (!suntekSettings.accounting?.allowTransactionImpact) {
    return null;
  }

  return (
    <PrimaryButton
      size="regular"
      onClick={()=> switchJournal(JobNames.BTDo, selectedElement.id)}>
      View Journal
    </PrimaryButton>
  );
  */
 return null;
}

function ListCommands() {
  const jobListContext = useContext(JobListViewContext);
  const [selectedPopupMenuItem, setSelectedPopupMenuItem] = useState<ActionButtonItem|null>(null);
  
  const selectedElement = jobListContext.selectedElement as BTLocalDOListItem;

  const {deleteItem, edit, view, copy, viewBillings} = useSelectedOperations();
  const [showGlobalYesNoDialog] = useGlobalYesNoDialog();
  const [showGlobalOkDialog] = useGlobalOkDialog();
  const appContext = useContext(ApplicationContext);
  const { viewReport } = useReportViewer();

  function hasOpenedViewOrEditFor(id: number) {
    return jobListContext.hasOpenedScreenStartingWithUrl(`/brokerageTrucking/localDO/edit/${id}`) || jobListContext.hasOpenedScreenStartingWithUrl(`/brokerageTrucking/localDO/view/${id}`);
  }

  function hasOpenedNew() {
    return jobListContext.hasOpenedScreenStartingWithUrl(`/brokerageTrucking/localDO/add`);
  }

  const onPopupClose = () => {
    setSelectedPopupMenuItem(null);
  }

  async function onSubMenuClick(fmsSubMenu: FmsSubMenu) {
    setSelectedPopupMenuItem(null);

    if (!selectedElement) {
      return;
    }
    
    const args = await getSelectedSubMenuArgs(fmsSubMenu, JobNames.BTDo, selectedElement, appContext, showGlobalYesNoDialog, showGlobalOkDialog);
    if(args){
      viewReport(args, "", true);
    }
  }

  const listSec = findSecurityTask(appContext, FmsSecTask.BTLocalDO);

  const hasSelectedRow = !!selectedElement;
  const canBeDeleted = hasSelectedRow && listSec?.grantDel;
  const canBeCopied = hasSelectedRow && !hasOpenedNew() && listSec?.grantAdd;
  const canBeAdd = !hasOpenedNew() && listSec?.grantAdd;
  const canBeEdit = hasSelectedRow && listSec?.grantEdit;

  return (
    <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"}>
      <div className="ifms-common-no-vertical-separator">
        <UniqueLinkButton name='btLocalDo-list-add-button' display="primary" size="regular" link="/brokerageTrucking/localDO/add" disabled={!canBeAdd}
                          label="New"/>&nbsp;
        <PrimaryButton name='btLocalDo-list-view-button' size="regular" disabled={!hasSelectedRow} onClick={view}>View</PrimaryButton>&nbsp;
        <PrimaryButton name='btLocalDo-list-edit-button' size="regular" disabled={!canBeEdit} onClick={edit}>Edit</PrimaryButton>&nbsp;
        <PrimaryButton name='btLocalDo-list-delete-button' size="regular" disabled={!canBeDeleted} onClick={deleteItem}>Delete</PrimaryButton>&nbsp;
        <PrimaryButton name='btLocalDo-list-copy-button' size="regular" disabled={!canBeCopied} onClick={copy}>Copy</PrimaryButton>
      </div>
      <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"}>
        {/*<PrimaryButton size="regular" onClick={viewBillings}><FontAwesomeIcon icon={faCalculator} />&nbsp; View Billings</PrimaryButton>&nbsp;*/}
        {appContext.user?.isSuntekAdmin && <PrimaryButton size="regular" onClick={() => setSelectedPopupMenuItem({label: 'Delete History (Local D/O)', popupWidth: 1120, popupComponent: <DeleteHistory jobName={JobNames.BTDo} /> })}>Delete History</PrimaryButton>}
      </div>
      {!!selectedPopupMenuItem && !!selectedPopupMenuItem.popupComponent ? (
        <IfmsModal isBlueHeader cancelOnEsc onCancel={onPopupClose} draggable isOpen={!!selectedPopupMenuItem} title={selectedPopupMenuItem?.popupLabel || selectedPopupMenuItem?.label} width={`${selectedPopupMenuItem?.popupWidth || 760}px`}>
          {cloneElement(selectedPopupMenuItem.popupComponent!, {onPopupClose})}
        </IfmsModal>
      ) : null}
      {!!selectedPopupMenuItem && !!selectedPopupMenuItem.subMenu ? onSubMenuClick(selectedPopupMenuItem.subMenu) : null}
    </div>
  );
}

function ListToolbar() {
  return (
    <>
      <ListViewShortcutMenu />
    </>
  );
}

function ListViewExtras({
  hideLogHistory
}: any,
) {
  useFunctionKeys({onFunction: onFunctionKey});

  const appContext = useContext(ApplicationContext);
  const jobListContext = useContext(JobListViewContext);
  const history = useHistory();
  const listSec = findSecurityTask(appContext, FmsSecTask.BTLocalDO);

  const {copy, create, edit, view, viewBillings, switchToOrder} = useSelectedOperations();

  const [unprocessedFkey, setUnprocessedFkey] = useState<string | null>(null);

  useEffect(() => {
      if (!unprocessedFkey) {
        return;
      }

      doProcessFkey();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [unprocessedFkey]
  );

  function doProcessFkey() {
    if (unprocessedFkey === 'F6') {
      switchToOrder();
    } else if (unprocessedFkey === "F2") {
      if(listSec?.grantAdd)
        create();
    } else if (unprocessedFkey === "CTRL+F2") {
      if(listSec?.grantAdd)
        copy();
    } else if (unprocessedFkey === "F3") {
      if(listSec?.grantEdit)
        edit();
    } else if (unprocessedFkey === "F9") {
      view();
    } else if (unprocessedFkey === "F11") {
      jobListContext.reloadData();
    } else if (unprocessedFkey === "F8") {
      jobListContext.setInfoAreaContent(jobListContext.infoAreaContent === 'memo' ? 'none' : 'memo');
    }

    setUnprocessedFkey(null);
  }

  function onFunctionKey(fkey: string) {
    if (['F6', 'F2', 'CTRL+F2', 'F3', 'F9', 'F11', 'F8'].indexOf(fkey) >= 0) {
      setUnprocessedFkey(fkey);
      return true;
    }

    return false;
  }

  const infoHeadline = `D/O No: ${(jobListContext.selectedElement as BTLocalDOListItem|null)?.refNo ?? ''}`;

  return (
    <InfoAreaDrawer
      showContent={jobListContext.infoAreaContent}
      jobName={JobNames.BTDo}
      jobId={(jobListContext.selectedElement as BTLocalDOListItem | null)?.id ?? 0}
      customTabs={[
        {
          headline: 'Billings Info',
          contentLoader: loadInfoAreaInvoiceBillCrDb,
          params: { appContext, jobListContext, history, infoHeadline }
        },
      ]}
      onClose={() => jobListContext.setInfoAreaContent('none')}
      hideLogHistory={hideLogHistory}
    />
  );
}

function formatData(data:Array<BTLocalDOListItem>) {
  return data.map(d => ({
    ...d,
  }));
}

/**
 * Concrete implementation for Local D/O List screen
 *
 * @class ListView
 * @extends {AbstractListView}
 */
class ListView extends AbstractListView {

  async fetchAndFormatData(api: any, search: Search): Promise<DataFetchResult> {
    const apiResult = await api.getListItems(
      JobNames.BTDo,
      'BTLocalDOListItem',
      BTLocalDOListItem.calculateSearchParameters(search, BTLocalDOListItem.MapSearchFields),
      1,
      search.pageSize,
      );

    if (!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
      return {data: [], totalCount: 0};
    }

    return {data: formatData(apiResult.entities), totalCount: apiResult.totalCount};
  }

  getCustomFilterRenderers(): ListCustomFilterRenderer[] {
    return [];
  }

  getInfoAreaEntityId() {
    return constants.infoAreaEntity.oceanImportMbl;
  }

  getRowRenderers(): ListRowRenderer[] {
    return BTLocalDOListItem.getExportCollection().map(x => {
      const colRenderer:ListRowRenderer = { accessor: x.dataIndex, Cell: TextAlignLeftRenderer };
      if(x.align === XCol.XAlignType.Center) colRenderer.Cell = TextRenderer;
      if (x.dataIndex === "status") {  colRenderer.Cell = IndicatorRenderer;}
      else if (x.dataIndex === "draft") { colRenderer.Cell = NullableCheckboxIconRenderer;}
      else if (x.dataIndex === "orderNo") {colRenderer.Cell = OrderNoRenderer}
      else if(x.type === XCol.XCellType.Date) colRenderer.Cell = DateRenderer;
      else if(x.type === XCol.XCellType.DateTime) colRenderer.Cell = DateTimeRenderer;
      return colRenderer;
    });
  }

  getExportRenderers(): ExportRowRenderer[] {
    const colRenderer = [];
    colRenderer.push({ accessor: 'status', changedValue: (value: any) => { return value['status'] === 'PC' ? 'Period Close' : '' } });
    return colRenderer;
  }

  getDefaultOrderBy(): ListOrderBy {
    return {
      orderBy: 'u2Date',
      orderByAscending: false,
    };
  }

  getTableSettings(): TableSettings {
    const tsettings =  brokerageTruckingLocalDOList;
    const cols = BTLocalDOListItem.getExportCollection();
    tsettings.columns = cols.map<TableColumn>(x => {
      return { ...x, accessor: x.dataIndex, Header: x.text, filterType: undefined, filterTypeV2: x.type};
    });
    return tsettings;
  }

  renderCommands() {
    return (
      <ListCommands/>
    );
  }

  renderBeforeConfigureButton() {
    return (
      <ListToolbar/>
    );
  }

  renderExtras(hideLogHistory: boolean) {
    return <ListViewExtras hideLogHistory={hideLogHistory} />
  }

  getViewUrlFor(row: BTLocalDOListItem) {
    return row && row.id ? `/brokerageTrucking/localDO/view/${row.id}` : '';
  }

  getListViewTitle() {
    return 'Local D/O List';
  };

  renderAdditionalCommands() {
   // return <JobListSuntekCommand jobName={JobNames.BTDo} keyProp='id' showAdjustBalance={false} />;
    return null;
  }

  hasRightClickContext(): boolean {
    return true;
  }

  renderRightClickContext(context: RightClickContext, dismiss: VoidFunction): React.ReactNode {
    return <RightClickMenu dismiss={dismiss} />;
  }

  commandsAfterMemoLogBtn():React.ReactNode{
    return <AfterMemoLogButtonCommands />
  }

  transactionImpactBtn(): React.ReactNode {
    return <TrancationImpactButtonCommands/>
  }
  
  useLogHistory(): boolean {
    return true;
  }
}

export default ListView;